import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { SummaryAssessmentForm } from '../../features/SummaryAssessmentForm/SummaryAssessmentForm'

import { InterviewStateContext } from 'components/modules/interview/context'
import { getSkillTitles } from 'components/modules/interview/model'
import { useContext } from 'hooks'

import styles from './Summary.module.scss'

export const Summary = () => {
  const state = useContext(InterviewStateContext)

  const {
    assessment: { control, fields, watch },
    sections,
    hasEmptyScore,
  } = state

  const skillTitles = getSkillTitles(sections)

  return (
    <Box align="center" className={styles.summary} tagName="section">
      <Box className={styles.content} direction="column">
        <h2 className={styles.title}>{t`Summary`}</h2>
        <MessageAlert
          message={t`Make sure to score every category.`}
          variant="error"
          isInitialised={hasEmptyScore}
        />
        <SummaryAssessmentForm {...{ control, fields, skillTitles, watch }} />
      </Box>
    </Box>
  )
}
